import CurrentChartPresenter from "./Chart/ChartCurrentPresenter";

export const Current = {
    Chart : CurrentChartPresenter
}

export default Current;